import { render, staticRenderFns } from "./Bind.vue?vue&type=template&id=5b1a36ac&scoped=true&"
import script from "./Bind.vue?vue&type=script&lang=js&"
export * from "./Bind.vue?vue&type=script&lang=js&"
import style0 from "./Bind.vue?vue&type=style&index=0&id=5b1a36ac&prod&lang=less&scoped=true&"
import style1 from "./Bind.vue?vue&type=style&index=1&id=5b1a36ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1a36ac",
  null
  
)

export default component.exports